import { render, staticRenderFns } from "./fancyDynamicTable.vue?vue&type=template&id=2b9056ee&scoped=true&"
import script from "./fancyDynamicTable.vue?vue&type=script&lang=js&"
export * from "./fancyDynamicTable.vue?vue&type=script&lang=js&"
import style0 from "./fancyDynamicTable.vue?vue&type=style&index=0&id=2b9056ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9056ee",
  null
  
)

component.options.__file = "fancyDynamicTable.vue"
export default component.exports